/**
 * DEV-021 · Presentation-only human-readable labels for the internal
 * ``sales_actions[].action_type`` catalogue keys. Mirrors the
 * ``TYPE_LABEL_FALLBACK`` map used by ``SalesActionsSection.jsx``
 * (the operational catalogue), extended to sentence case so it reads
 * naturally in customer-visible lists (Sales To-do, Calendar
 * tooltips, etc.).
 *
 * The Sales Action *catalogue* is fetched from the backend via
 * ``api.listSalesActionTypes()`` when available (see
 * ``SalesActionsSection.jsx``); this helper is the safe presentation
 * fallback when a catalogue lookup isn't wired in (Sales To-do
 * consumes a flat aggregate that doesn't include the display label,
 * so we humanise the key here rather than round-trip an extra API
 * call).
 *
 * Absolutely no API/schema/business-logic changes here — display
 * formatting only.
 */

export const SALES_ACTION_TYPE_LABELS = {
    call_customer:    "Call customer",
    follow_up_quote:  "Follow up quote",
    arrange_survey:   "Arrange survey",
    follow_up_survey: "Follow up survey",
    chase_decision:   "Chase decision",
    finance_followup: "Finance follow-up",
    send_information: "Send information",
    customer_meeting: "Customer meeting",
    other:            "Other",
};

/** Convert a snake_case internal action key into a human label. */
export function humaniseSalesActionType(key) {
    if (!key) return "";
    if (SALES_ACTION_TYPE_LABELS[key]) return SALES_ACTION_TYPE_LABELS[key];
    const words = String(key).replace(/[_-]+/g, " ").trim();
    if (!words) return "";
    return words.charAt(0).toUpperCase() + words.slice(1);
}
